import * as types from './mutation-types'
import * as actions from './actions'

const state = {
  lifecyclesError: '',
  lifecyclesLoading: 0,
  lifecycleDataLoading: 0,
  lifecyclesPlatforms: {},
  lifecyclesPhases: {},
  setType: {},
  getLifecycleTasksError: '',
  getLifecycleTasksLoading: 0,
  lifecycleTasks: [],
  getLifecycleTasksForUserError: '',
  getLifecycleTasksForUserLoading: 0,
  lifecycleTasksForUser: [],
  createTaskCommentError: '',
  createTaskCommentLoading: 0,
  createdComment: {},
  removeTaskCommentError: '',
  removeTaskCommentLoading: 0,
  removedComment: {},
  editTaskCommentError: '',
  editTaskCommentLoading: 0,
  editedComment: {},
  getTaskTypesError: '',
  getTaskTypesLoading: 0,
  taskTypes: [],
  createTaskError: '',
  createTaskLoading: 0,
  createdTask: {},
  deleteTaskError: '',
  deleteTaskLoading: 0,
  deletedTask: {},
  editTaskError: '',
  editTaskLoading: 0,
  editedTask: {}
}

const getters = {
  lifecyclesError: state => state.lifecyclesError,
  lifecyclesLoading: state => state.lifecyclesLoading,
  lifecycleDataLoading: state => state.lifecycleDataLoading,
  lifecyclesPlatforms: state => state.lifecyclesPlatforms,
  lifecyclesPhases: state => state.lifecyclesPhases,
  setType: state => state.setType,
  getLifecycleTasksError: state => state.getLifecycleTasksError,
  getLifecycleTasksLoading: state => state.getLifecycleTasksLoading,
  lifecycleTasks: state => state.lifecycleTasks,
  getLifecycleTasksForUserError: state => state.getLifecycleTasksForUserError,
  getLifecycleTasksForUserLoading: state => state.getLifecycleTasksForUserLoading,
  lifecycleTasksForUser: state => state.lifecycleTasksForUser,
  createTaskCommentError: state => state.createTaskCommentError,
  createTaskCommentLoading: state => state.createTaskCommentLoading,
  createdComment: state => state.createdComment,
  removeTaskCommentError: state => state.removeTaskCommentError,
  removeTaskCommentLoading: state => state.removeTaskCommentLoading,
  removedComment: state => state.removedComment,
  editTaskCommentError: state => state.editTaskCommentError,
  editTaskCommentLoading: state => state.editTaskCommentLoading,
  editedComment: state => state.editedComment,
  getTaskTypesError: state => state.getTaskTypesError,
  getTaskTypesLoading: state => state.getTaskTypesLoading,
  taskTypes: state => state.taskTypes,
  createTaskError: state => state.createTaskError,
  createTaskLoading: state => state.createTaskLoading,
  createdTask: state => state.createdTask,
  deleteTaskError: state => state.deleteTaskError,
  deleteTaskLoading: state => state.deleteTaskLoading,
  deletedTask: state => state.deletedTask,
  editTaskError: state => state.editTaskError,
  editTaskLoading: state => state.editTaskLoading,
  editedTask: state => state.editedTask,
}

const mutations = {
  [types.GET_LIFECYCLES_PLATFORMS_REQUEST] (state) {
    state.lifecycleDataLoading += 1
    state.lifecyclesError = ''
    state.lifecyclesPlatforms = {}
  },
  [types.GET_LIFECYCLES_PLATFORMS_SUCCESS] (state, lifecyclesPlatforms) {
    state.lifecycleDataLoading -= 1
    state.lifecyclesError = ''
    state.lifecyclesPlatforms = lifecyclesPlatforms
  },
  [types.GET_LIFECYCLES_PLATFORMS_FAILURE] (state, lifecyclesError) {
    state.lifecycleDataLoading -= 1
    state.lifecyclesError = lifecyclesError
    state.lifecyclesPlatforms = {}
  },
  [types.GET_LIFECYCLES_PHASES_REQUEST] (state) {
    state.lifecycleDataLoading += 1
    state.lifecyclesError = ''
    state.lifecyclesPhases = {}
  },
  [types.GET_LIFECYCLES_PHASES_SUCCESS] (state, lifecyclesPhases) {
    state.lifecycleDataLoading -= 1
    state.lifecyclesError = ''
    state.lifecyclesPhases = lifecyclesPhases
  },
  [types.GET_LIFECYCLES_PHASES_FAILURE] (state, lifecyclesError) {
    state.lifecycleDataLoading -= 1
    state.lifecyclesError = lifecyclesError
    state.lifecyclesPhases = {}
  },
  [types.SET_LIFECYCLE_PLATFORMS] (state) {
    state.lifecyclesPlatforms = {}
  },
  [types.GET_LIFECYLCE_TASKS_REQUEST](state){
    state.getLifecycleTasksLoading = true
    state.getLifecycleTasksError = ''
    state.lifecycleTasks = []
  },
  [types.GET_LIFECYLCE_TASKS_SUCCESS](state, lifecycleTasks){
    state.getLifecycleTasksLoading = false
    state.getLifecycleTasksError = ''
    state.lifecycleTasks = lifecycleTasks
  },
  [types.GET_LIFECYLCE_TASKS_FAILURE](state, error){
    state.getLifecycleTasksLoading = false
    state.getLifecycleTasksError = error
    state.lifecycleTasks = []
  },
  [types.GET_LIFECYLCE_TASKS_FOR_USER_REQUEST](state){
    state.getLifecycleTasksForUserLoading = true
    state.getLifecycleTasksForUserError = ''
    state.lifecycleTasksForUser = []
  },
  [types.GET_LIFECYLCE_TASKS_FOR_USER_SUCCESS](state, lifecycleTasksForUser){
    state.getLifecycleTasksForUserLoading = false
    state.getLifecycleTasksForUserError = ''
    state.lifecycleTasksForUser = lifecycleTasksForUser
  },
  [types.GET_LIFECYLCE_TASKS_FOR_USER_FAILURE](state, error){
    state.getLifecycleTasksForUserLoading = false
    state.getLifecycleTasksForUserError = error
    state.lifecycleTasksForUser = []
  },
  [types.CREATE_TASK_COMMENT_REQUEST](state){
    state.createTaskCommentLoading = true
    state.createTaskCommentError = ''
    state.createdComment = {}
  },
  [types.CREATE_TASK_COMMENT_SUCCESS](state, createdComment){
    state.createTaskCommentLoading = false
    state.createTaskCommentError = ''
    state.createdComment = createdComment
  },
  [types.CREATE_TASK_COMMENT_FAILURE](state, error){
    state.createTaskCommentLoading = false
    state.createTaskCommentError = error
    state.createdComment = {}
  },
  [types.REMOVE_TASK_COMMENT_REQUEST](state){
    state.removeTaskCommentLoading = true
    state.removeTaskCommentError = ''
    state.removedComment = {}
  },
  [types.REMOVE_TASK_COMMENT_SUCCESS](state, removedComment){
    state.removeTaskCommentLoading = false
    state.removeTaskCommentError = ''
    state.removedComment = removedComment
  },
  [types.REMOVE_TASK_COMMENT_FAILURE](state, error){
    state.removeTaskCommentLoading = false
    state.removeTaskCommentError = error
    state.removedComment = {}
  },
  [types.EDIT_TASK_COMMENT_REQUEST](state){
    state.editTaskCommentLoading = true
    state.editTaskCommentError = ''
    state.editedComment = {}
  },
  [types.EDIT_TASK_COMMENT_SUCCESS](state, editedComment){
    state.editTaskCommentLoading = false
    state.editTaskCommentError = ''
    state.editedComment = editedComment
  },
  [types.EDIT_TASK_COMMENT_FAILURE](state, error){
    state.editTaskCommentLoading = false
    state.editTaskCommentError = error
    state.editedComment = {}
  },
  [types.GET_TASK_TYPES_REQUEST](state){
    state.getTaskTypesLoading = true
    state.getTaskTypesError = ''
    state.taskTypes = []
  },
  [types.GET_TASK_TYPES_SUCCESS](state, taskTypes){
    state.getTaskTypesLoading = false
    state.getTaskTypesError = ''
    state.taskTypes = taskTypes
  },
  [types.GET_TASK_TYPES_FAILURE](state, error){
    state.getTaskTypesLoading = false
    state.getTaskTypesError = error
    state.taskTypes = []
  },
  [types.CREATE_TASK_REQUEST](state){
    state.createTaskLoading = true
    state.createTaskError = ''
    state.createdTask = {}
  },
  [types.CREATE_TASK_SUCCESS](state, createdTask){
    state.createTaskLoading = false
    state.createTaskError = ''
    state.createdTask = createdTask
  },
  [types.CREATE_TASK_FAILURE](state, error){
    state.createTaskLoading = false
    state.createTaskError = error
    state.createdTask = {}
  },
  [types.DELETE_TASK_REQUEST](state){
    state.deleteTaskLoading = true
    state.deleteTaskError = ''
    state.deletedTask = {}
  },
  [types.DELETE_TASK_SUCCESS](state, deletedTask){
    state.deleteTaskLoading = false
    state.deleteTaskError = ''
    state.deletedTask = deletedTask
  },
  [types.DELETE_TASK_FAILURE](state, error){
    state.deleteTaskLoading = false
    state.deleteTaskError = error
    state.deletedTask = {}
  },
  [types.EDIT_TASK_REQUEST](state){
    state.editTaskLoading = true
    state.editTaskError = ''
    state.editedTask = {}
  },
  [types.EDIT_TASK_SUCCESS](state, editedTask){
    state.editTaskLoading = false
    state.editTaskError = ''
    state.editedTask = editedTask
  },
  [types.EDIT_TASK_FAILURE](state, error){
    state.editTaskLoading = false
    state.editTaskError = error
    state.editedTask = {}
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
